import { render, staticRenderFns } from "./ServiceCenterHeader.vue?vue&type=template&id=48590c50&scoped=true&"
import script from "./ServiceCenterHeader.vue?vue&type=script&lang=js&"
export * from "./ServiceCenterHeader.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCenterHeader.vue?vue&type=style&index=0&id=48590c50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48590c50",
  null
  
)

export default component.exports